<template>
  <div class="flex flex-col" style="gap: 16px">
    <h4 style="font-weight: bold; font-size: 22px; color: #FFFFFF; margin: 0">
      Contact Us
    </h4>
    <a
      href="mailto:rocnovel@col.com"
      style="font-size: 16px; color: #FFFFFF; text-decoration: none"
    >
      rocnovel@col.com
    </a>
  </div>
</template>
